import { createTemplateFactory } from "@ember/template-factory";
export default createTemplateFactory(
/*
  {{#if (and this.search.inTopicContext (not @searchTopics))}}
  <SearchMenu::BrowserSearchTip />
{{else}}
  <ConditionalLoadingSection @isLoading={{this.loading}}>
    <div class="results">
      <PluginOutlet
        @name="search-menu-results-top"
        @outletArgs={{hash
          closeSearchMenu=@closeSearchMenu
          searchTerm=this.search.activeGlobalSearchTerm
          inTopicContext=this.search.inTopicContext
          searchTopics=@searchTopics
        }}
      />
      {{#if @suggestionKeyword}}
        <SearchMenu::Results::Assistant
          @suggestionKeyword={{@suggestionKeyword}}
          @results={{@suggestionResults}}
          @closeSearchMenu={{@closeSearchMenu}}
          @searchTermChanged={{@searchTermChanged}}
        />
      {{else if this.termTooShort}}
        <div class="no-results">{{i18n "search.too_short"}}</div>
      {{else if this.noTopicResults}}
        <div class="no-results">{{i18n "search.no_results"}}</div>
      {{else if this.renderInitialOptions}}
        <SearchMenu::Results::InitialOptions
          @closeSearchMenu={{@closeSearchMenu}}
          @searchTermChanged={{@searchTermChanged}}
        />
      {{else}}
        {{#if (and (not @searchTopics) (not @inPMInboxContext))}}
          {{! render the first couple suggestions before a search has been performed}}
          <SearchMenu::Results::InitialOptions
            @closeSearchMenu={{@closeSearchMenu}}
            @searchTermChanged={{@searchTermChanged}}
          />
        {{/if}}

        {{#if (and @searchTopics this.resultTypesWithComponent)}}
          {{! render results after a search has been performed }}
          <SearchMenu::Results::Types
            @resultTypes={{this.resultTypesWithComponent}}
            @topicResultsOnly={{true}}
            @closeSearchMenu={{@closeSearchMenu}}
            @searchLogId={{this.searchLogId}}
          />
          <SearchMenu::Results::MoreLink
            @updateTypeFilter={{@updateTypeFilter}}
            @triggerSearch={{@triggerSearch}}
            @resultTypes={{this.resultTypesWithComponent}}
            @closeSearchMenu={{@closeSearchMenu}}
            @searchTermChanged={{@searchTermChanged}}
          />
        {{else if
          (and
            (not @inPMInboxContext)
            (not @searchTopics)
            this.resultTypesWithComponent
          )
        }}
          <SearchMenu::Results::Types
            @resultTypes={{this.resultTypesWithComponent}}
            @closeSearchMenu={{@closeSearchMenu}}
            @searchTermChanged={{@searchTermChanged}}
            @displayNameWithUser={{true}}
            @searchLogId={{this.searchLogId}}
          />
        {{/if}}
      {{/if}}
      <PluginOutlet
        @name="search-menu-results-bottom"
        @outletArgs={{hash
          inTopicContext=this.search.inTopicContext
          searchTermChanged=@searchTermChanged
          searchTopics=@searchTopics
          closeSearchMenu=@closeSearchMenu
        }}
      />
    </div>
  </ConditionalLoadingSection>
{{/if}}
*/
{
  "id": "DXWs0FV5",
  "block": "[[[41,[28,[37,1],[[30,0,[\"search\",\"inTopicContext\"]],[28,[37,2],[[30,1]],null]],null],[[[1,\"  \"],[8,[39,3],null,null,null],[1,\"\\n\"]],[]],[[[1,\"  \"],[8,[39,4],null,[[\"@isLoading\"],[[30,0,[\"loading\"]]]],[[\"default\"],[[[[1,\"\\n    \"],[10,0],[14,0,\"results\"],[12],[1,\"\\n      \"],[8,[39,5],null,[[\"@name\",\"@outletArgs\"],[\"search-menu-results-top\",[28,[37,6],null,[[\"closeSearchMenu\",\"searchTerm\",\"inTopicContext\",\"searchTopics\"],[[30,2],[30,0,[\"search\",\"activeGlobalSearchTerm\"]],[30,0,[\"search\",\"inTopicContext\"]],[30,1]]]]]],null],[1,\"\\n\"],[41,[30,3],[[[1,\"        \"],[8,[39,7],null,[[\"@suggestionKeyword\",\"@results\",\"@closeSearchMenu\",\"@searchTermChanged\"],[[30,3],[30,4],[30,2],[30,5]]],null],[1,\"\\n\"]],[]],[[[41,[30,0,[\"termTooShort\"]],[[[1,\"        \"],[10,0],[14,0,\"no-results\"],[12],[1,[28,[35,8],[\"search.too_short\"],null]],[13],[1,\"\\n\"]],[]],[[[41,[30,0,[\"noTopicResults\"]],[[[1,\"        \"],[10,0],[14,0,\"no-results\"],[12],[1,[28,[35,8],[\"search.no_results\"],null]],[13],[1,\"\\n\"]],[]],[[[41,[30,0,[\"renderInitialOptions\"]],[[[1,\"        \"],[8,[39,9],null,[[\"@closeSearchMenu\",\"@searchTermChanged\"],[[30,2],[30,5]]],null],[1,\"\\n\"]],[]],[[[41,[28,[37,1],[[28,[37,2],[[30,1]],null],[28,[37,2],[[30,6]],null]],null],[[[1,\"          \"],[8,[39,9],null,[[\"@closeSearchMenu\",\"@searchTermChanged\"],[[30,2],[30,5]]],null],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[28,[37,1],[[30,1],[30,0,[\"resultTypesWithComponent\"]]],null],[[[1,\"          \"],[8,[39,10],null,[[\"@resultTypes\",\"@topicResultsOnly\",\"@closeSearchMenu\",\"@searchLogId\"],[[30,0,[\"resultTypesWithComponent\"]],true,[30,2],[30,0,[\"searchLogId\"]]]],null],[1,\"\\n          \"],[8,[39,11],null,[[\"@updateTypeFilter\",\"@triggerSearch\",\"@resultTypes\",\"@closeSearchMenu\",\"@searchTermChanged\"],[[30,7],[30,8],[30,0,[\"resultTypesWithComponent\"]],[30,2],[30,5]]],null],[1,\"\\n\"]],[]],[[[41,[28,[37,1],[[28,[37,2],[[30,6]],null],[28,[37,2],[[30,1]],null],[30,0,[\"resultTypesWithComponent\"]]],null],[[[1,\"          \"],[8,[39,10],null,[[\"@resultTypes\",\"@closeSearchMenu\",\"@searchTermChanged\",\"@displayNameWithUser\",\"@searchLogId\"],[[30,0,[\"resultTypesWithComponent\"]],[30,2],[30,5],true,[30,0,[\"searchLogId\"]]]],null],[1,\"\\n        \"]],[]],null]],[]]],[1,\"      \"]],[]]]],[]]]],[]]]],[]]],[1,\"      \"],[8,[39,5],null,[[\"@name\",\"@outletArgs\"],[\"search-menu-results-bottom\",[28,[37,6],null,[[\"inTopicContext\",\"searchTermChanged\",\"searchTopics\",\"closeSearchMenu\"],[[30,0,[\"search\",\"inTopicContext\"]],[30,5],[30,1],[30,2]]]]]],null],[1,\"\\n    \"],[13],[1,\"\\n  \"]],[]]]]],[1,\"\\n\"]],[]]]],[\"@searchTopics\",\"@closeSearchMenu\",\"@suggestionKeyword\",\"@suggestionResults\",\"@searchTermChanged\",\"@inPMInboxContext\",\"@updateTypeFilter\",\"@triggerSearch\"],false,[\"if\",\"and\",\"not\",\"search-menu/browser-search-tip\",\"conditional-loading-section\",\"plugin-outlet\",\"hash\",\"search-menu/results/assistant\",\"i18n\",\"search-menu/results/initial-options\",\"search-menu/results/types\",\"search-menu/results/more-link\"]]",
  "moduleName": "discourse/components/search-menu/results.hbs",
  "isStrictMode": false
});